import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createCategory, getHotSpotsCategories } from './hot-spot-categories.state';


export const withHotSpotsCategories = connect(
    state => ({
        hotSpotsCategories: state.dashboard.hotSpotsCategories,
    }),
    dispatch => bindActionCreators({
        getHotSpotsCategories,
        createCategory,
    }, dispatch),
);
